<template>
  <footer
    class="footer fob-hide-in-print"
    style="background: transparent; letter-spacing: 1px; line-height: 1.5rem;"
  >
    <div class="content has-text-centered">
      <p class="is-size-7" v-html="$gettext('footer.main')"></p>
      <p class="is-size-7 is-uppercase">
        <span v-html="$gettext('footer.link.imprint')"></span>
        <span v-html="$gettext('footer.link.privacyPolicy')"></span>
        <span v-html="$gettext('footer.link.contact')"></span>
      </p>
      <div class="is-size-7 has-text-grey-light">
        <span style="padding-right: 0.5rem;">FOBGUI {{version}}</span>
        <a v-if="this.hasUpdateAvailable" class="has-text-grey-light" style="padding-right: 0.5rem;" @click="reloadPage" :title="$gettext('ReloadPage')"><translate>UpdateAvailable</translate></a>
        <a v-if="this.isAuthorized" class="has-text-grey-light" style="padding-right: 0.5rem;" @click="dropLocalStorage">Browserspeicher löschen</a>
      </div>
    </div>
  </footer>
</template>

<script>

import { isLowerVersion } from '@/utils'
import { mapGetters } from 'vuex'
import * as Cookies from 'js-cookie'

export default {
  name: 'fob-footer',
  computed: {
    ...mapGetters({
      isAuthorized: 'user/isAuthorized',
      version: 'getVersion',
      serverVersion: 'getServerVersion'
    }),
    hasUpdateAvailable () {
      return isLowerVersion(this.version, this.serverVersion)
    }
  },
  methods: {
    dropLocalStorage () {
      this.$dialog.confirm({
        title: 'Browserspeicher löschen',
        message: 'Sind Sie sicher, dass Sie alle im Browser gespeicherten FOB-relevanten Einstellungen <b>löschen</b> möchten? Diese Aktion kann nicht rückgängig gemacht werden!',
        cancelText: 'Abbrechen',
        confirmText: 'Speicher leeren',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          // remove cookie data
          Cookies.remove(process.env.COOKIE_KEY_MACO, {
            path: '',
            domain: process.env.COOKIE_DOMAIN
          })
          // remove localstorage
          window.localStorage.removeItem('de.ul.fob')
          this.$dialog.alert({
            message: 'Speicher geleert! Seite wird neu geladen.',
            type: 'is-danger',
            onConfirm: () => location.reload()
          })
        }
      })
    },
    reloadPage () {
      window.location.reload(true)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Footer.vue